import React from 'react';
import PropTypes from 'prop-types';
import LinkIntercept from 'components/linkIntercept/LinkIntercept';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

const propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  target: PropTypes.string,
  settings: PropTypes.shape({
    rows: PropTypes.number,
  }),
};

function ListLink({ slug, title, target, settings }) {
  const { rows } = settings;

  if (target === '_blank') {
    return (
      <Root rows={rows}>
        <a href={slug} target={target}>
          <LinkContent>
            <LinkTitle>{title}</LinkTitle>
            <FontAwesomeIcon icon='external-link-alt' />
          </LinkContent>
        </a>
      </Root>
    );
  }

  return (
    <Root rows={rows}>
      <LinkIntercept to={`/${slug}`} target={target}>
        <LinkContent>
          <LinkTitle>{title}</LinkTitle>
          <FontAwesomeIcon icon='external-link-alt' />
        </LinkContent>
      </LinkIntercept>
    </Root>
  );
}

ListLink.propTypes = propTypes;

export default ListLink;

const Root = styled.li`
  background-color: ${({ theme }) => theme.colors.links.popularCountries.background};
  border: 1px solid ${({ theme }) => theme.colors.links.popularCountries.border};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.light};
  }

  ${({ rows }) =>
    rows &&
    rows > 1 &&
    `
    width: ${100 / rows}%;
  `}
`;

const LinkContent = styled.div`
  ${flexbox({
    justifyContent: 'space-between',
    alignItems: 'center',
  })}

  padding: 15px 25px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.links.popularCountries.text};

  ${mediaQueries.fromAndBelow.desktop`
    padding: 15px;
  `}
`;

const LinkTitle = styled.span``;
